<template>
  <el-input
    v-model="inputText"
    placeholder="点击选择"
    @click="clickInput"
  ></el-input>
  <el-dialog v-model="dialogVisible" :title="title">
    <div class="search-form">
      <div
        v-for="item in search"
        :key="item.value"
        :class="
          item.size === 'large' ? 'search-form-large' : 'search-form-small'
        "
      >
        <component
          :key="item.value"
          v-model="form[item.value]"
          v-bind="item"
          :is="item.component ? item.component : 'el-input'"
          :placeholder="item.placeholder ? item.placeholder : '请输入'"
          :start-placeholder="
            item.startPlaceholder ? item.startPlaceholder : '开始日期'
          "
          :end-placeholder="
            item.endPlaceholder ? item.endPlaceholder : '结束日期'
          "
          @change="handleSearch"
        ></component>
      </div>
    </div>
    <el-table
      v-loading="loading"
      :data="dataSource"
      style="width: 100%"
      height="650"
      :row-key="rowKey"
      :highlight-current-row="!selection"
      @current-change="handleCurrentRow"
      @select="handleSelection"
      @select-all="handleSelection"
      v-if="columns.length > 0"
      ref="tableRef"
    >
      <el-table-column type="selection" width="55" v-if="selection" />
      <template v-for="item in columns" :key="item.prop">
        <!---scope使用组件时-->
        <el-table-column
          v-if="item.scopeComponent"
          :label="item.label"
          :width="item.width"
          :align="'center'"
        >
          <template #default="scope">
            <!---handleScope用于对scope数据二次处理，默认不传-->
            <component
              v-model="scope.row[item.prop]"
              :is="item.scopeComponent"
              :scope="item.handleScope ? item.handleScope(scope) : scope"
              :value="item.prop"
              :custom="item?.custom ?? [{ value: '正常', class: 'normal' }]"
              @click="handleClick('scope', scope.row)"
            ></component>
          </template>
        </el-table-column>
        <!---scope使用函数时-->
        <el-table-column
          v-else-if="item.scopeFun"
          :label="item.label"
          :width="item.width"
          :align="'center'"
        >
          <template #default="scope">
            {{ item.scopeFun(scope) }}
          </template>
        </el-table-column>
        <!--默认的列表展现-->
        <el-table-column
          v-else
          :label="item.label"
          :width="item.width"
          :align="'center'"
        >
          <template #default="scope">
            {{ scope.row[item.prop] ? scope.row[item.prop] : "--" }}
          </template>
        </el-table-column>
      </template>
    </el-table>
    <div class="table-pagination" v-if="page.total > 0">
      <el-pagination
        v-model:current-page="page.pageNumber"
        v-model:page-size="page.limit"
        :page-sizes="[10, 20, 30, 50]"
        layout="total, sizes, prev, pager, next, jumper"
        :total="page.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <template #footer>
      <span class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave"> 保存 </el-button>
      </span>
    </template>
  </el-dialog>
</template>
<script>
import {
  getCurrentInstance,
  defineComponent,
  ref,
  provide,
  reactive,
  onMounted,
  watch,
  toRefs,
  computed,
  nextTick,
} from "vue";

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { replaceObjectKeys } from "@pansy/utils";

export default defineComponent({
  name: "inputModal",
  components: {},
  props: {
    /** v-model选中项绑定值*/
    modelValue: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    /** 弹框的标题*/
    title: {
      type: String,
      default: "",
      required: true,
    },
    /** 弹框搜索*/
    search: {
      type: Array,
      default: () => {
        return [];
      },
    },
    /** 弹框表头*/
    columns: {
      type: Array,
      default: () => {
        return [];
      },
      required: true,
    },
    /** 表格行key的取值*/
    rowKey: {
      type: String,
      default: "id",
    },
    /** 弹框请求列表的接口*/
    url: {
      type: String,
      default: "",
      required: true,
    },
    /**请求列表数据之后的操作*/
    afterGet: {
      type: Function,
      default: null,
    },
    /**请求列表数据成功后转换数据*/
    field: {
      type: Object,
      default: () => {
        return {};
      },
    },
    /** 是否显示列表的选择,*/
    selection: {
      type: Boolean,
      default: true,
    },
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance();
    const tableRef = ref();
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const state = reactive({
      inputText: "",
      form: {},
      dialogVisible: false,
      dataSource: [],
      currentSelection: [],
      page: {
        limit: 10,
        pageNumber: 1,
        total: 0,
      },
    });
    onMounted(() => {});
    watch(
      () => props.modelValue,
      (n, o) => {
        console.log(n, o);
        if (
          (n && n.length > 0 && !o) ||
          (n && n.length > 0 && o && o.length === 0)
        ) {
          if (props.modelValue && props.modelValue.length > 0) {
            let arr = props.modelValue.map((item) => {
              return item.name;
            });
            state.inputText = arr.join("、");
          }
        }
      }
    );
    watch(
      () => state.dialogVisible,
      (n) => {
        if (n) {
          getData();
        }
      }
    );
    const clickInput = () => {
      state.dialogVisible = true;
    };
    const getData = () => {
      let formParams = state.form;
      let params = {
        ...formParams,
        page: state.page.pageNumber,
        limit: state.page.limit,
      };
      if (props.url) {
        proxy.$api[props.url](params, "get").then((res) => {
          state.loading = false;
          if (res.rows) {
            state.page.total = res.total;
            state.dataSource = res.rows;
          } else if (res.data) {
            state.page.total = 0;
            state.dataSource = props.afterGet
              ? props.afterGet(res.data)
              : res.data;
          }
          state.dataSource = props.field
            ? replaceObjectKeys(state.dataSource, props.field, {
                simplify: false,
              })
            : state.dataSource;
          state.dataSource.forEach((item, i) => {
            state.currentSelection.forEach((cur, ci) => {
              if (item[props.rowKey] === cur[props.rowKey]) {
                if (props.selection) {
                  setTimeout(() => {
                    tableRef.value.toggleRowSelection(item);
                  }, 300);
                } else {
                  setTimeout(() => {
                    tableRef.value.setCurrentRow(item);
                  }, 300);
                }
              }
            });
          });
        });
      }
    };
    //表格选择
    const handleSelection = (val) => {
      state.dataSource.forEach((item) => {
        state.currentSelection.forEach((cur, ci) => {
          if (item[props.rowKey] === cur[props.rowKey]) {
            state.currentSelection.splice(ci, 1);
          }
        });
      });
      state.currentSelection = state.currentSelection.concat(val);
    };
    //表格单选
    const handleCurrentRow = (val) => {
      if (!props.selection && val) {
        state.currentSelection = [val];
      }
    };
    //点击翻页
    const handleCurrentChange = () => {
      console.log(state.page);
      getData();
    };
    // 点击保存
    const handleSave = () => {
      emit("update:modelValue", state.currentSelection);
      let arr = state.currentSelection.map((item) => {
        return item.name;
      });
      state.inputText = arr.join("、");
      state.dialogVisible = false;
    };
    //点击搜索
    const handleSearch = () => {
      getData();
    };
    return {
      tableRef,
      ...toRefs(state),
      clickInput,
      handleSelection,
      handleCurrentChange,
      handleSave,
      handleSearch,
      handleCurrentRow,
    };
  },
});
</script>
<style scoped lang="less">
.table-pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.search-form {
  height: 100%;
  overflow: hidden;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 10px;
  > div {
    margin-right: 8px;
    &.search-form-small {
      width: 130px;
    }
    &.search-form-large {
      width: 300px;
    }
  }
}
</style>
